export const getUpdatedSections = (discountSections, neededSection, discount, property, value) => {
  return discountSections.map(sec => {
    if (sec.id === neededSection.id) {
      neededSection.discounts.map(dis => {
        if (dis.id === discount.id) {
          dis[property] = value;
        }
        return dis
      })
    }
    return sec
  })
}

// /**
//  *
//  * @param discountSections {[discountSectionsInterface]}
//  * @return {[workSheetObjectInterface]}
//  */
// export const getWorksheetObjects = (discountSections) => {
//   return discountSections.reduce((total, discountSection) => {
//     const wizardLogic = discountSection.wizardLogic ? JSON.parse(discountSection.wizardLogic) : {
//       index: 0,
//     };
//     const existingSheetsIndex = total.findIndex(existingSheetObject => existingSheetObject.index === wizardLogic.index);
//     if (existingSheetsIndex >= 0) {
//       total[existingSheetsIndex].discountSections.push(discountSection)
//     } else {
//       total.push({
//         index: total.length,
//         discountSections: [discountSection]
//       })
//     }
//     return total
//   }, [])
// }
/**
 *
 * @param discountSections {[discountSectionsInterface]}
 * @return {number}
 */
export const getWorksheetsCount = (discountSections) => {
  return discountSections.reduce((maxIndex, discountSection) => {
    const wizardLogic = getParsedWizardLogic(discountSection);
    if ((wizardLogic.index + 1) > maxIndex) {
      maxIndex = wizardLogic.index + 1;
    }
    return maxIndex
  }, 1)
}

/**
 *
 * @param discountSections {[discountSectionsInterface]}
 * @param index {number}
 * @return {[discountSectionsInterface]}
 */
export const getCurrentWorkSheetSections = (discountSections, index) => {
  return discountSections.filter(discountSection => {
    return getParsedWizardLogic(discountSection).index === index
  })
}

/**
 *
 * @param discountSections {[discountSectionsInterface]}
 * @return {boolean}
 */
export const getLowesIMEActive = (discountSections) => {
  return discountSections.length && discountSections.every(discountSection => {
    return getParsedWizardLogic(discountSection).forLowesIME
  })
}

/**
 * parsed logic
 * @param discountSection {discountSectionsInterface}
 * @param index {number}
 * @return {discountWizardLogicInterface}
 */
export const getParsedWizardLogic = (discountSection, index) => {
  return discountSection && discountSection.wizardLogic
    ? JSON.parse(discountSection.wizardLogic)
    : JSON.parse(getDiscountSectionDefaultWizardLogic(index))
}

export const getDiscountSectionDefaultWizardLogic = (index = 0, displayOptions = [], isLowesIMEActive) => {
  return JSON.stringify({index, displayOptions, forLowesIME: isLowesIMEActive || false})
}

export const getUpdatedDiscountSectionsWithWizardLogic = (discountSections, wizardLogic, workSheetIndex) => {
  const stringifiedLogic = JSON.stringify(wizardLogic);
  return discountSections.map(discountSection => {
    const parsedLogic = getParsedWizardLogic(discountSection, workSheetIndex);
    if (parsedLogic.index === workSheetIndex) {
      discountSection.wizardLogic = stringifiedLogic;
    }
    return discountSection
  });
}
